import api from './index';

let exports = {};

exports.getMerchtAssetNatureListByRealId = function (data, callback) {
    api.get('/mercht/asset/nature/list/get/by/realId')
        .params(data)
        .done(callback)
        .go();
};
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/assetNature.js
// module id = 422
// module chunks = 0